import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const Container = styled.div`
  height: 200px;
  .extra-note {
    font-size: ${Variables.font_sizes.medium};
    color: ${Variables.colors.complementary_700};
    line-height: 1.56;
    margin-bottom: 8px;
    padding: 0 10px 6px;
  }
  div:last-child{
    height: 160px;
  }
`;